import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numbertowords'
})
export class NumbertowordsPipe implements PipeTransform {


  a = [
    '',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'ten',
    'eleven',
    'twelve',
    'thirteen',
    'fourteen',
    'fifteen',
    'sixteen',
    'seventeen',
    'eighteen',
    'nineteen',
    'twenty'];

  transform(value: any, args?: any): any {
    if (value) {
      let num: any = Number(value);
      if (num) {
        if (!num) { return ''; }
        var str = this.a[Number([value])]
        return str.toUpperCase();
      } else {
        return '';
      }
    } else {
      return '';
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pipe/numbertowords.pipe.ts